/**
 * The payload for a support case about a ride. The server checks a case's ride id against
 * local rides only, so an Intertown trip (`kind: 'intertown'`) goes in the notes instead:
 * sent as `rideId` it would be refused and no case would be created. For a local ride this
 * is exactly what the sheet always sent.
 */
export const supportCaseFor = (ride, category, notes) => {
  if (ride?.kind !== 'intertown') return { rideId: ride?.id, category, notes };
  const trip = `Intertown trip #${String(ride.id || '').slice(0, 8).toUpperCase()}`;
  const extra = String(notes || '').trim();
  return { rideId: undefined, category, notes: extra ? `${trip} - ${extra}` : trip };
};
